var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s)
                if (Object.prototype.hasOwnProperty.call(s, p))
                    t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try {
            step(generator.next(value));
        }
        catch (e) {
            reject(e);
        } }
        function rejected(value) { try {
            step(generator["throw"](value));
        }
        catch (e) {
            reject(e);
        } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function () { if (t[0] & 1)
            throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function () { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f)
            throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _)
            try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
                    return t;
                if (y = 0, t)
                    op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return { value: op[1], done: false };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [0];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2])
                            _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            }
            catch (e) {
                op = [6, e];
                y = 0;
            }
            finally {
                f = t = 0;
            }
        if (op[0] & 5)
            throw op[1];
        return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './PromoActionsControlPage.scss';
import { Modal, message, Image, Button, Form, Input, Upload, Select, Spin } from 'antd';
import { CloseOutlined, PlusOutlined, UploadOutlined, EditOutlined } from '@ant-design/icons';
import { useState } from 'react';
import { useGetPromoActionsQuery, useDeletePromoActionMutation, useCreatePromoActionMutation, useUpdatePromoActionMutation, useGetPromoActionsByCityQuery, } from '@/services/promoActionsApi';
import { useGetCitiesQuery } from '@/services/citiesApi';
import { DownOutlined } from '@ant-design/icons';
var Option = Select.Option;
var PromoActionsControlPage = function () {
    var _a = useState(null), selectedCity = _a[0], setSelectedCity = _a[1];
    // 🔹 если город выбран → тянем данные по городу, иначе все акции
    var _b = useGetPromoActionsQuery({ page: 1, limit: 20 }, { skip: !!selectedCity }), data = _b.data, isLoading = _b.isLoading, isError = _b.isError, refetch = _b.refetch;
    var _c = useGetPromoActionsByCityQuery({ cityId: selectedCity, page: 1, limit: 20 }, { skip: !selectedCity }), promoData = _c.data, refetchByCity = _c.refetch;
    var deletePromoAction = useDeletePromoActionMutation()[0];
    var createPromoAction = useCreatePromoActionMutation()[0];
    var updatePromoAction = useUpdatePromoActionMutation()[0];
    var _d = useGetCitiesQuery(), cities = _d.data, isCitiesLoading = _d.isLoading;
    var _e = useState(null), visibleIndex = _e[0], setVisibleIndex = _e[1];
    var _f = useState(false), isModalVisible = _f[0], setIsModalVisible = _f[1];
    var _g = useState([]), fileList = _g[0], setFileList = _g[1];
    var _h = useState(false), uploading = _h[0], setUploading = _h[1];
    var _j = useState(null), editingPromo = _j[0], setEditingPromo = _j[1];
    var form = Form.useForm()[0];
    var handleDelete = function (id) {
        Modal.confirm({
            title: 'Удалить акцию?',
            content: 'Вы действительно хотите удалить эту акцию?',
            okText: 'Удалить',
            okType: 'danger',
            cancelText: 'Отмена',
            onOk: function () {
                return __awaiter(void 0, void 0, void 0, function () {
                    var err_1;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                _a.trys.push([0, 2, , 3]);
                                return [4 /*yield*/, deletePromoAction(id).unwrap()];
                            case 1:
                                _a.sent();
                                message.success('Акция удалена');
                                selectedCity ? refetchByCity() : refetch();
                                return [3 /*break*/, 3];
                            case 2:
                                err_1 = _a.sent();
                                console.error(err_1);
                                message.error('Ошибка при удалении акции');
                                return [3 /*break*/, 3];
                            case 3: return [2 /*return*/];
                        }
                    });
                });
            },
        });
    };
    var handleOpenModal = function (promo) {
        var _a;
        if (promo) {
            setEditingPromo(promo);
            form.setFieldsValue({
                title: promo.title,
                description: promo.description,
                cityId: ((_a = promo.city) === null || _a === void 0 ? void 0 : _a.id) || promo.cityId,
            });
            setFileList([]);
        }
        else {
            setEditingPromo(null);
            form.resetFields();
            setFileList([]);
        }
        setIsModalVisible(true);
    };
    var handleSubmit = function () {
        return __awaiter(void 0, void 0, void 0, function () {
            var values, formData, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 6, , 7]);
                        return [4 /*yield*/, form.validateFields()];
                    case 1:
                        values = _a.sent();
                        formData = new FormData();
                        formData.append('title', values.title);
                        formData.append('description', values.description || '');
                        if (values.cityId)
                            formData.append('cityId', String(values.cityId));
                        if (fileList[0])
                            formData.append('file', fileList[0].originFileObj);
                        setUploading(true);
                        if (!editingPromo)
                            return [3 /*break*/, 3];
                        return [4 /*yield*/, updatePromoAction({ id: editingPromo.id, data: formData }).unwrap()];
                    case 2:
                        _a.sent();
                        message.success('Акция обновлена');
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, createPromoAction(formData).unwrap()];
                    case 4:
                        _a.sent();
                        message.success('Акция создана');
                        _a.label = 5;
                    case 5:
                        setUploading(false);
                        setIsModalVisible(false);
                        setFileList([]);
                        form.resetFields();
                        setEditingPromo(null);
                        selectedCity ? refetchByCity() : refetch();
                        return [3 /*break*/, 7];
                    case 6:
                        err_2 = _a.sent();
                        console.error(err_2);
                        message.error('Ошибка при сохранении акции');
                        setUploading(false);
                        return [3 /*break*/, 7];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    if (isLoading && !selectedCity)
        return _jsx("p", { children: "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430 \u0430\u043A\u0446\u0438\u0439..." });
    if (isError)
        return _jsx("p", { children: "\u041E\u0448\u0438\u0431\u043A\u0430 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0438 \u0430\u043A\u0446\u0438\u0439" });
    // 🔹 данные для отображения
    var promos = selectedCity ? promoData === null || promoData === void 0 ? void 0 : promoData.data : data === null || data === void 0 ? void 0 : data.data;
    return (_jsxs("div", __assign({ className: "PromoActionsControlPage" }, { children: [_jsxs("div", __assign({ className: "titleBlock" }, { children: [_jsx("span", { children: "\u041F\u0440\u043E\u043C\u043E-\u0430\u043A\u0446\u0438\u0438" }), _jsx(Button, __assign({ type: "primary", icon: _jsx(PlusOutlined, {}), onClick: function () { return handleOpenModal(); } }, { children: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0430\u043A\u0446\u0438\u044E" })), _jsx(Select, __assign({ showSearch: true, placeholder: _jsx("span", __assign({ style: { fontSize: 14 } }, { children: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0433\u043E\u0440\u043E\u0434" })), optionFilterProp: "children", onChange: function (value) { return setSelectedCity(value || null); }, allowClear: true, style: { fontSize: 13, minWidth: 180 }, dropdownStyle: { fontSize: 12 }, suffixIcon: _jsx(DownOutlined, { style: { fontSize: 11 } }) }, { children: cities === null || cities === void 0 ? void 0 : cities.map(function (city) { return (_jsx(Option, __assign({ value: city.id, label: city.name, style: { fontSize: 12 } }, { children: city.name }), city.id)); }) }))] })), _jsx("div", __assign({ className: "promoActionsGrid" }, { children: _jsx(Image.PreviewGroup, __assign({ preview: {
                        visible: visibleIndex !== null,
                        current: visibleIndex !== null && visibleIndex !== void 0 ? visibleIndex : 0,
                        onVisibleChange: function (visible) {
                            if (!visible)
                                setVisibleIndex(null);
                        },
                    } }, { children: promos === null || promos === void 0 ? void 0 : promos.map(function (promo, index) {
                        return (_jsxs("div", __assign({ className: "promoCard" }, { children: [_jsxs("div", __assign({ onClick: function () { return setVisibleIndex(index); }, className: "promoImageWrapper" }, { children: [_jsx(EditOutlined, { onClick: function (e) {
                                                e.stopPropagation();
                                                handleOpenModal(promo);
                                            }, className: "editIcon" }), _jsx(CloseOutlined, { onClick: function (e) {
                                                e.stopPropagation();
                                                handleDelete(promo.id);
                                            }, className: "deleteIcon" }), _jsx(Image, { src: promo.fileUrl, alt: promo.title, style: { width: '100%', height: '140px', objectFit: 'cover', borderRadius: 8 } })] })), _jsxs("div", __assign({ className: "promoInfo" }, { children: [_jsx("p", __assign({ className: "promoTitle" }, { children: promo.title })), promo.description && _jsx("p", __assign({ className: "promoDescription" }, { children: promo.description })), promo.city && _jsxs("p", __assign({ className: "promoCity" }, { children: ["\u0413\u043E\u0440\u043E\u0434: ", promo.city.name] }))] }))] }), promo.id));
                    }) })) })), _jsx(Modal, __assign({ title: editingPromo ? 'Редактировать промо-акцию' : 'Создать промо-акцию', open: isModalVisible, onOk: handleSubmit, onCancel: function () { setIsModalVisible(false); setFileList([]); setEditingPromo(null); }, okText: "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C", cancelText: "\u041E\u0442\u043C\u0435\u043D\u0430", confirmLoading: uploading }, { children: _jsxs(Form, __assign({ form: form, layout: "vertical" }, { children: [_jsx(Form.Item, __assign({ label: "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435", name: "title", rules: [{ required: true, message: 'Введите название акции' }] }, { children: _jsx(Input, { placeholder: "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0430\u043A\u0446\u0438\u0438" }) })), _jsx(Form.Item, __assign({ label: "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435", name: "description" }, { children: _jsx(Input.TextArea, { placeholder: "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u0430\u043A\u0446\u0438\u0438", rows: 3 }) })), _jsx(Form.Item, __assign({ label: "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430 \u043A\u0430\u0440\u0442\u0438\u043D\u043A\u0438" }, { children: _jsx(Upload, __assign({ beforeUpload: function () { return false; }, onChange: function (_a) {
                                    var fileList = _a.fileList;
                                    return setFileList(fileList);
                                }, fileList: fileList, maxCount: 1, accept: "image/*", listType: "picture" }, { children: _jsx(Button, __assign({ icon: _jsx(UploadOutlined, {}) }, { children: "\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u0438\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435" })) })) })), _jsx(Form.Item, __assign({ label: "\u0413\u043E\u0440\u043E\u0434", name: "cityId" }, { children: isCitiesLoading ? (_jsx(Spin, {})) : (_jsx(Select, __assign({ showSearch: true, placeholder: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0433\u043E\u0440\u043E\u0434", allowClear: true }, { children: cities === null || cities === void 0 ? void 0 : cities.map(function (city) { return (_jsx(Option, __assign({ value: city.id, label: city.name }, { children: city.name }), city.id)); }) }))) }))] })) }))] })));
};
export default PromoActionsControlPage;
